module.exports = __webpack_public_path__ + "img/wordpress_2.cbc04904.png";